import {createSlice} from '@reduxjs/toolkit';

import storeSliceNames from '../../consts/storeSliceNames';
import helpers from '../../utils/helpers';

const initialState = {
    devices: {},
    localDevices: {},
    isRetailDevicesLoading: false,
    authTokens: {},
};

const retailSlice = createSlice({
    name: storeSliceNames.retail,
    initialState,
    reducers: {
        setRetailDeviceData(state, action) {
            const device = action.payload;

            state.devices[device.serialNumber] = device;
        },
        setRetailLocalDeviceData(state, action) {
            const device = action.payload;

            state.localDevices[device.codentify] = device;
        },
        setIsRetailDevicesLoading(state, action) {
            state.isRetailDevicesLoading = action.payload;
        },
        setUserRewardsIsLoading(state, action) {
            const {serialNumber, isLoading} = action.payload;

            state.devices[serialNumber].rewards = {...(state?.devices?.[serialNumber]?.rewards || {}), isLoading};
        },
        removeRetailDevice(state, action) {
            const serialNumber = action.payload;

            delete state.devices?.[serialNumber];
        },
        updateRetailDeviceData(state, action) {
            const {serialNumber, data} = action.payload;

            if (!serialNumber || !data) return;

            const currentData = state.devices[serialNumber];

            if (currentData) {
                const mergedData = helpers.mergeDeep(currentData, data);

                state.devices[serialNumber] = currentData ? mergedData : data;
            }
        },
        setRetailBadges(state, action) {
            const {serialNumber, badges} = action.payload;

            return {
                ...state,
                badges: {
                    ...state.badges,
                    [serialNumber]: badges,
                },
            };
        },
        setRetailDeviceAuthToken(state, action) {
            const {codentify, token} = action.payload;

            state.authTokens[codentify] = token;
        },
        removeRetailDeviceAuthToken(state, action) {
            const {codentify} = action.payload;

            delete state.authTokens[codentify];
        },
    },
});

export const setRetailDeviceData = (device) => retailSlice.actions.setRetailDeviceData(device);

export const setRetailLocalDeviceData = (device) => retailSlice.actions.setRetailLocalDeviceData(device);

export const setRetailDeviceAuthToken = (codentify, token) =>
    retailSlice.actions.setRetailDeviceAuthToken({
        codentify,
        token,
    });

export const removeRetailDeviceAuthToken = (codentify) =>
    retailSlice.actions.removeRetailDeviceAuthToken({
        codentify,
    });

export const removeRetailDevice = (serialNumber) => retailSlice.actions.removeRetailDevice(serialNumber);

export const setIsRetailDevicesLoading = (serialNumber) => retailSlice.actions.setIsRetailDevicesLoading(serialNumber);

export const setUserRewardsIsLoading = (serialNumber, isLoading) =>
    retailSlice.actions.setUserRewardsIsLoading({
        serialNumber,
        isLoading,
    });

export const updateRetailDeviceData = (serialNumber, data) =>
    retailSlice.actions.updateRetailDeviceData({
        serialNumber,
        data,
    });

export const setRetailBadges = (serialNumber, badges) =>
    retailSlice.actions.setRetailBadges({
        serialNumber,
        badges,
    });

export default retailSlice.reducer;
